import { useEffect, useState } from 'react';
import { api } from '../api/client';

type Zustand = 'pruefe' | 'ok' | 'ohne-db' | 'fehler';

const TEXT: Record<Zustand, string> = {
  pruefe: 'Verbindung wird geprüft …',
  ok: 'Server verbunden',
  'ohne-db': 'Server erreichbar, Datenbank nicht',
  fehler: 'Server nicht erreichbar',
};

export function ApiStatus() {
  const [zustand, setZustand] = useState<Zustand>('pruefe');

  useEffect(() => {
    let aktiv = true;
    api
      .health()
      .then((h) => aktiv && setZustand(h?.datenbank === 'ok' ? 'ok' : 'ohne-db'))
      .catch(() => aktiv && setZustand('fehler'));
    return () => {
      aktiv = false;
    };
  }, []);

  const klasse =
    zustand === 'ok' ? 'api-status--ok' : zustand === 'pruefe' ? '' : 'api-status--fehler';

  // Status immer mit Text, nie nur Farbe.
  return (
    <span className={`api-status ${klasse}`} role="status">
      <span className="api-status__punkt" aria-hidden="true" />
      {TEXT[zustand]}
    </span>
  );
}
